"use strict";
/**
 * Types extracted from https://discord.com/developers/docs/topics/permissions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleFlags = void 0;
/**
 * @see {@link https://discord.com/developers/docs/topics/permissions#role-object-role-flags}
 */
var RoleFlags;
(function (RoleFlags) {
    /**
     * Role can be selected by members in an onboarding prompt
     */
    RoleFlags[RoleFlags["InPrompt"] = 1] = "InPrompt";
})(RoleFlags || (exports.RoleFlags = RoleFlags = {}));
//# sourceMappingURL=permissions.js.map